/** @deprecated Import from colorTokens.js — kept for backward compatibility. */
module.exports = require("./colorTokens.js");
